/**
 * index.tsx
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ClerkProvider } from '@clerk/clerk-react'

// Use consistent styling
import 'sanitize.css/sanitize.css';

// Import root app
import { App } from 'app';

import { HelmetProvider } from 'react-helmet-async';

import { configureAppStore } from 'store/configureStore';

import reportWebVitals from 'reportWebVitals';

import { PostHogProvider} from 'posthog-js/react'

// Initialize languages
import './locales/i18n';

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://a08913939ea4396a928f9b96b312323d@o4505486547681280.ingest.us.sentry.io/4507306470539264",
  integrations: [],
});

// Posthog options
const posthogOptions = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
}

// Initialize Auth
const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY
if (!CLERK_PUBLISHABLE_KEY) {
    throw new Error("Missing Publishable Key")
}

// Initialize Redux store
export const store = configureAppStore();
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <PostHogProvider 
    apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
    options={posthogOptions}
  >
    <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY} appearance={{ layout: { termsPageUrl: 'https://www.notion.so/controlla/Terms-of-Use-Controlla-Voice-29ab0cc02f614042873151574b54cae7' } }}>
      <Provider store={store}>
        <HelmetProvider>
            <App />
        </HelmetProvider>
      </Provider>
    </ClerkProvider>
  </PostHogProvider>
);

// Hot reloadable translation json files
if (module.hot) {
  module.hot.accept(['./locales/i18n'], () => {
    // No need to render the App again because i18next works with the hooks
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
export {theme} from "./styles/theme";